import APIClient from '@/shared/http/clients/api'

const resourceName = 'QMATemplate'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const ImportableByQMAPIVS = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/ImportableByQMAPIVS`, data, config)
const ImportableByQMALVPIT = (lv, pit, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/ImportableByQMALVPIT/${lv}/${pit}`, data, config)
const GetStatusTemplateQMA = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetStatusTemplateQMA`, data, config)
const GetQMATemplateParaTodosTemplatesGrid = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetQMATemplateParaTodosTemplatesGrid?limit=${limit}&index=${index}`, data, config)
const DuplicarTemplate = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/DuplicarTemplate`, data, config)
const CriarNovoTemplateWeb = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/CriarNovoTemplateWeb`, data, config)
const editarTemplateQMA = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/editarTemplateQMA`, data, config)
const GetQMATemplatePainel = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetQMATemplatePainel/${id}`, data, config)
const EdicaoQMATemplate = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/EdicaoQMATemplate`, data, config)
const GetLogQma = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetLogQma/${id}`, data, config)
const CriacaoQMAPreRequisitoWeb = (templateId, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/CriacaoQMAPreRequisitoWeb/${templateId}`, data, config)
const GetAvaliacaoMetadadoTemplate = (template, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetAvaliacaoMetadadoTemplate/${template}`, data, config)
const uploadImagemPerguntaTemplate = (perguntaId, descricaoImg, empresaId, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/uploadImagemPerguntaTemplate/${perguntaId}/${descricaoImg}/${empresaId}`, data, {
  ...config,
  transformRequest: [(d, headers) => {
    delete headers['Content-Type']
    return d
  }]
})
const DownloadPerguntaTemplate = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/DownloadPerguntaTemplate`, data, config)
const uploadImagemPerguntaEdicaoTemplate = (perguntaId, descricaoImg, exclusao, empresaId, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/uploadImagemPerguntaEdicaoTemplate/${perguntaId}/${descricaoImg}/${exclusao}/${empresaId}`, data, {
  ...config,
  transformRequest: [(d, headers) => {
    delete headers['Content-Type']
    return d
  }]
})
const inativaAtivaQMATemplate = (id, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/inativaAtivaQMATemplate/${id}`, data, config)
const excluirTemplate = (id, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/excluirTemplate/${id}`, data, config)
// 2026-05-29: publicação/despublicação explícitas (salvar deixou de publicar automaticamente)
const PublicarQMATemplate = (id, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/PublicarQMATemplate/${id}`, data, config)
const DespublicarQMATemplate = (id, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/DespublicarQMATemplate/${id}`, data, config)

const ApruserRepository = {
  ImportableByQMAPIVS,
  ImportableByQMALVPIT,
  GetStatusTemplateQMA,
  GetQMATemplateParaTodosTemplatesGrid,
  CriarNovoTemplateWeb,
  DuplicarTemplate,
  editarTemplateQMA,
  GetQMATemplatePainel,
  EdicaoQMATemplate,
  GetLogQma,
  CriacaoQMAPreRequisitoWeb,
  GetAvaliacaoMetadadoTemplate,
  uploadImagemPerguntaTemplate,
  DownloadPerguntaTemplate,
  uploadImagemPerguntaEdicaoTemplate,
  inativaAtivaQMATemplate,
  excluirTemplate,
  PublicarQMATemplate,
  DespublicarQMATemplate
}

export default ApruserRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/qmaTemplate.js